const Modal = {
  baseStyle: {
    borderRadius: '6px',
    header: {
      fontSize: 'calc(15px * var(--font-size-title, 1))',
      fontFamily: 'var(--font-family-title)',
      fontWeight: 600,
      padding: '20px',
      color: 'var(--page-text, inherit)',
    },
    body: {
      padding: '0 20px',
      color: 'var(--page-text, inherit)',
      marginBottom: '4px',
    },
    footer: {
      padding: '20px',
    },
  },
};

export default Modal;
